// Pix Utilties ######################

import store from "@/store/store";
import * as Classes from "@/classes/classes";
import CfgApp from "@/assets/cfg/CfgApp.json";
import * as Utils from "@/utils/utils.js";
import { m } from "@/utils/utils.js";
import { eventBus } from '@/main';

export const test1 = (data) => {
	m("test1");
}


// Check file is valid Image File
export const validatePicFile = (file) => {
	m("validatePicFile", file);
	const answer = {
		ok: true,
		mess:[],
	}

	if(!file.name.match(/\.(jpe?g|png|gif)$/i)){
		answer.ok = false;
		answer.mess.push('Oops! Selected file name is not an image.');
	}

	if(!file.type.match(/image.(jpeg|png|gif)/)){
		answer.ok = false;
		answer.mess.push('Oops! Selected file type is not an image.');
	}

	if(file.size > CfgApp.maxUplSize * 1000000){
		answer.ok = false;
		answer.mess.push('Oops! Selected file is larger than ' + CfgApp.maxUplSize + ' MB.');
	}

	if (!answer.ok) {
		answer.mess.push("Please choose another file.");
	}

	return answer;
}  


// Chain #1 Part 1: Upload File
export const uploadFile = (file, rec) => {
	m("upload file beg");

	const reader = new FileReader();

	reader.onload = function(e) {
		buildMainImage(e.target.result, rec);
	};
	m("uploading...");
	reader.readAsDataURL(file);

	m("upload file end");
}

// Chain #1 Part2: Build Main Image
const buildMainImage = (imgData, rec) => {
	m("build main image beg", rec);

	let image = new Image();
	image.onload = function(){
		buildRefImage(image, rec);
	};
	image.src = imgData;
	m("build main image end");
}


// Chain #1 Part 3: Build Reference Image with manageable size
const buildRefImage = (srcImage, rec) => {
	m("build ref image beg");

	let imgData = buildOneThumb(srcImage, "ref", rec.type);
	let image = new Image();
	image.onload = function(){
		rec.refImage = image;
		buildThumbs(image, rec);
		endProcess("app/addPicRec", rec);
	};
	image.src = imgData;

	m("build ref image end");
}


// Chain #2 Part 1: Rotate Image
export const goRotate = (rec) => {

	m("img utils: go rotate beg", rec);

	let image = new Image();
	if (!rec.refImage) {
		m("creating new ref image from max");
		image.onload = function(){
			rec.refImage = image;
			createRotRef(rec);
		};
		image.src = rec.imgs.max;
	} else {
		m("already have ref image", rec.refImage.width, rec.refImage.height);
		createRotRef(rec);
	}
	m("img utils: go rotate end");
}


// Chain #2 Part 2: Create Rotated Reference Image
const createRotRef = (rec) => {
	m("img utils create rotref", rec);

	let rotImageData = rotateImage(rec.refImage, rec.rot, rec.type);

	let image = new Image();
	image.onload = function(){
		buildThumbs(image, rec);
		endProcess("app/updPicRec", rec);
	};
	image.src = rotImageData;
}


// End of chains
const endProcess = (action, rec) => {
	let data = {
		step: rec.step,
		rec: rec,
	}
	store.dispatch(action, data);
} 


// Rotate from Image Object, return Image Data ==========
const rotateImage = (srcImage, rot, type) => {
	m("rotate old image", srcImage.width);

	let canvas = document.createElement("canvas");
	let ctx = canvas.getContext("2d");
	
	if (rot==0 || rot==180) {
		canvas.width = srcImage.width;
		canvas.height = srcImage.height;
	} else {
		canvas.width = srcImage.height;
		canvas.height = srcImage.width;
	}

	m("width", canvas.width);
	m("height", canvas.height);

	ctx.clearRect(0, 0, canvas.width, canvas.height);

	if (rot !=0) {
		m("rotating " + rot + " degrees");
		ctx.rotate(rot * Math.PI / 180);
		if (rot==90) ctx.translate(0, -canvas.width);
		if (rot==180) ctx.translate(-canvas.width, -canvas.height);
		if (rot==270) ctx.translate(-canvas.height, 0);
	}	

	ctx.drawImage(srcImage, 0, 0);
	// ctx.drawImage(image, 0, 0, newDim.w, newDim.h);
	m("quality", CfgApp.pixQuality);
	var newSrc = canvas.toDataURL(type, CfgApp.pixQuality);
	// var newSrc = canvas.toDataURL(CfgApp.pixFormat, CfgApp.pixQuality);
	m(CfgApp.pixFormat + " length: >>>>>>>", newSrc.length);
	return newSrc;

	
}


// Build All Thumbnails
const buildThumbs = (srcImage, rec) => {
	m("img utils: build thumbs beg", rec);
	rec.imgs.max = buildOneThumb(srcImage, "max", rec.type);
	rec.imgs.mid = buildOneThumb(srcImage, "mid", rec.type);
	rec.imgs.min = buildOneThumb(srcImage, "min", rec.type);
	m("img utils: build thumbs end");
}


// Build 1 Thumbnaail from Image Object, return Image Data ==========
const buildOneThumb = (srcImage, thmSize="mid", type) => {

	m("buildOneThumb", srcImage.width, srcImage.height, thmSize, type);

	let thmWidth = CfgApp.pixDims[thmSize].width;
	let thmHeight = CfgApp.pixDims[thmSize].height;
	let newDim = calcPicSize(srcImage.width, srcImage.height, thmWidth,  thmHeight);

	m("newDim", newDim);

	let canvas = document.createElement("canvas");
	let ctx = canvas.getContext("2d");
	canvas.width = newDim.width;
	canvas.height = newDim.height;

	m("width", canvas.width);
	m("height", canvas.height);

	ctx.clearRect(0, 0, canvas.width, canvas.height);
	ctx.drawImage(srcImage, 0, 0, newDim.width, newDim.height);

	var newSrc = canvas.toDataURL(type, CfgApp.pixQuality);
	// var newSrc = canvas.toDataURL(CfgApp.pixFormat, CfgApp.pixQuality);
	m(thmSize + " " + CfgApp.pixFormat + " length: >>>>>>>", newSrc.length);
	return newSrc;

}  


const calcPicSize = (imgW, imgH, maxW, maxH) => {
	m("calcPicSize");
	m(imgW, imgH, maxW, maxH);
	let newW = imgW;
	let newH = imgH;
	let ratio = imgW / imgH;
	if (ratio>=1) {
		m("ratio >=1");
		newW = maxW;
		newH = newW / ratio;
	} else {
		m("ratio <1");
		newH = maxH;
		newW = newH * ratio;
	}

	return {
		width: Math.floor(newW),
		height: Math.floor(newH)
	}
}


